import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=636024a0&"
import script from "./TextEditor.vue?vue&type=script&lang=js&"
export * from "./TextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636024a0')) {
      api.createRecord('636024a0', component.options)
    } else {
      api.reload('636024a0', component.options)
    }
    module.hot.accept("./TextEditor.vue?vue&type=template&id=636024a0&", function () {
      api.rerender('636024a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/popup/TextEditor.vue"
export default component.exports